/**
 * @extends storeLocator.StaticDataFeed
 * @constructor
 */
 function DaiwaDataSource() {
    $.extend(this, new storeLocator.StaticDataFeed);
  
    var that = this;
    $.get('https://sheets.googleapis.com/v4/spreadsheets/1p1HYxsYrGESHja4kAF0Jxg-ljSvD_hiOqPRy15qvfN8/values:batchGet?ranges=A1:Z1000&key=AIzaSyCHDtrvbqer-5m6QwwNVs8YbQ_YwAPFyZ8', function (data) {
      var csv = '';
      for (i = 1; i < data.valueRanges['0'].values.length; i++) {
        var cellData = [];
        for (x = 0; x < data.valueRanges['0'].values[i].length; x++) {
          cellData[x] = data.valueRanges['0'].values[i][x].replace(',', ';');
        }
        csv += cellData + '\n';
      }
      that.setStores(that.parse_(csv));

    });
  }
  /**
   * @const
   * @type {!storeLocator.FeatureSet}
   * @private
   */
  /**
   * @return {!storeLocator.FeatureSet}
   */
  DaiwaDataSource.prototype.getFeatures = function () {
    return this.FEATURES_;
  };
  
  /**
   * @private
   * @param {string} csv
   * @return {!Array.<!storeLocator.Store>}
   */
  DaiwaDataSource.prototype.parse_ = function (csv) {
  
    var stores = [];
    var rows = csv.split('\n');
    var headings = ['Name,General_Area,GPS_East,GPS_South,How_To_Fish_This_Spot,Spot_Number,Season,Season_Notes,Species,Techniques,Wind_Direction_Incoming,Wind_Direction_Outgoing,Longitude,Latitude,Featured'];

    
    for (var i = 0; i < rows.length; i++) {
      if(rows[i].length) {
        
        var singleCell = rows[i].split(',');
        var singleHead = headings[0].split(',');
        var singleObject = {};

        for (var x = 0; x < singleHead.length; x++) {
          if (singleCell[x] != null && singleCell[x] != '') {
            var cleanCell = singleCell[x].replace(";", ",")
            var cleanHeader = singleHead[x].replace(/(\r\n|\n|\r)/gm, "");
            singleObject[cleanHeader] = cleanCell;
          }
        }

        var name = singleObject.Name;
        var general_area = singleObject.General_Area;
        var gps_east = singleObject.GPS_East;
        var gps_south = singleObject.GPS_South;
        var how_to_fish = singleObject.How_To_Fish_This_Spot;
        var spot_number = singleObject.Spot_Number;
        var season = singleObject.Season;
        var season_notes = singleObject.Season_Notes;
        var species = singleObject.Species;
        var techniques = singleObject.Techniques;
        var wind_incoming = singleObject.Wind_Direction_Incoming;
        var wind_outgoing = singleObject.Wind_Direction_Outgoing;
        var latitude = singleObject.Latitude;
        var longitude = singleObject.Longitude;
        var directions = new storeLocator.Feature('1', '<a class="action directions" href="https://www.google.com/maps/search/?api=1&query=' + latitude, longitude + '" onclick="clickDirectionStore(\'' + name + '\')" target="_blank">DIRECTIONS</a>');
        var features = new storeLocator.FeatureSet(directions);
        var position = new google.maps.LatLng(latitude, longitude);
        var featured = singleObject.Featured;

        if(featured == 'Yes') {
          var marker_icon = 'https://cdn.shopify.com/s/files/1/0461/6726/1335/files/location-pin_9c6c87a9-636e-4796-914a-ba8bdebfda00.png?v=1633076846';
        }
        else {
          var marker_icon = 'https://cdn.shopify.com/s/files/1/0461/6726/1335/files/daiwa-marker.png?v=1613613203';
        }
    
        var store = new storeLocator.Store(i, position, features, {
          title: name,
          general_area: '<p>General Area: <span>' + general_area + '</span></p>',
          gps_east: '<p>GPS East: <span>' + gps_east + '</span></p>',
          gps_south: '<p>GPS South: <span>' + gps_south + '</span></p>',
          how_to_fish: '<p>How to Fish: <span>' + how_to_fish + '</span></p>',
          season: '<p>Season: <span>' + season + '</span></p>',
          season_notes: '<p>Season Notes: <span>' + season_notes + '</span></p>',
          species: '<p>Species: <span>' + species + '</span></p>',
          techniques: '<p>Techniques: <span>' + techniques + '</span></p>',
          wind_incoming: '<p>Wind Direction - Incoming: <span>' + wind_incoming + '</span></p>',
          wind_outgoing: '<p>Wind Direction - Outgoing: <span>' + wind_outgoing + '</span></p>',
          spot_number: '<p>Spot Number: <span>' + spot_number + '</span></p>',
          category: marker_icon
        });
        stores.push(store);
      }
    }
  
    return stores;
  
  };
  
  
  /**
   * Joins elements of an array that are non-empty and non-null.
   * @private
   * @param {!Array} arr array of elements to join.
   * @param {string} sep the separator.
   * @return {string}
   */
  DaiwaDataSource.prototype.join_ = function (arr, sep) {
    var parts = [];
    for (var i = 0, ii = arr.length; i < ii; i++) {
      arr[i] && parts.push(arr[i]);
    }
    return parts.join(sep);
  };
  
  /**
   * Very rudimentary CSV parsing - we know how this particular CSV is formatted.
   * IMPORTANT: Don't use this for general CSV parsing!
   * @private
   * @param {string} row
   * @return {Array.<string>}
   */
  DaiwaDataSource.prototype.parseRow_ = function (row) {
    // Strip leading quote.
    if (row.charAt(0) == '"') {
      row = row.substring(1);
    }
    // Strip trailing quote. There seems to be a character between the last quote
    // and the line ending, hence 2 instead of 1.
    if (row.charAt(row.length - 2) == '"') {
      row = row.substring(0, row.length - 2);
    }
  
    row = row.split('","');
  
    return row;
  };
  
  /**
   * Creates an object mapping headings to row elements.
   * @private
   * @param {Array.<string>} headings
   * @param {Array.<string>} row
   * @return {Object}
   */
  DaiwaDataSource.prototype.toObject_ = function (headings, row) {
    var result = {};
    for (var i = 0, ii = row.length; i < ii; i++) {
      result[headings[i]] = row[i];
    }
    return result;
  };